const PRIMARY_TEXT = `Documento não emitido.`;

const ERRO_SEM_ATIVIDADE = 'Não existe data de início da atividade como Contribuinte Individual no sistema do INSS (CNIS).';
const ERRO_SEM_ATIVIDADE_DESCRICAO= ERRO_SEM_ATIVIDADE + `<p>Siga para o serviço <a href="#" id='linkAtualizaCad' style="font-size: inherit">Atualizar Cadastro</a> para incluir a data.</p>`;
    
const IR_EXTRATO_CNIS = `<p>Siga para o serviço <a href="#" id='linkExtratoCnis' style="font-size: inherit">Extrato de Contribuição (CNIS)</a> para consultar os recolhimentos.</p>`;

const ERRO_SEM_RECOLHIMENTO_SUFICIENTE = `As contribuições como Contribuinte Individual não são suficientes para emissão.`;
    
const ERRO_SEM_RECOLHIMENTO_SUFIC_DESCRICAO = ERRO_SEM_RECOLHIMENTO_SUFICIENTE + IR_EXTRATO_CNIS;

const ERRO_SEM_RECOLHIMENTO = `Não existem contribuições como Contribuinte Individual no sistema do INSS.`;   

const ERRO_SEM_RECOLHIMENTO_DESCRICAO = ERRO_SEM_RECOLHIMENTO + IR_EXTRATO_CNIS;



export const resolveMsg = ({msg}) => {
   
    let secondaryText = ``;                       
    
    if(msg.indexOf("NIT informado não possui data de início de ocupação") > -1) {                
        secondaryText = ERRO_SEM_ATIVIDADE_DESCRICAO;            

    } else if(msg.indexOf("Não foi possível emitir a declaração. A quantidade de recolhimentos") > -1) {        
        secondaryText = ERRO_SEM_RECOLHIMENTO_SUFIC_DESCRICAO;   
        
    } else  {
        secondaryText = ERRO_SEM_RECOLHIMENTO_DESCRICAO;            
    }
    
    return{
        primaryText: PRIMARY_TEXT, 
        secondaryText: secondaryText
     };
    
};